module.exports = __webpack_public_path__ + "media/images/e-bilet/Logo-b9a43468d7780b5bf5a9de6d36b86f8f.svg";